<template>
  <v-card
      class="mx-auto"
      max-width="50%"
      outlined
  >
    <v-list-item two-line>
      <v-col cols="7">
        <div class="headline mb-5 mt-5">Mi Perfil</div>
        <v-divider></v-divider>

        <v-list-item-content>
          <v-list dense>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Nombre Completo</v-list-item-title>
                <v-list-item-subtitle>{{ usuario.nombre_completo }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Cedula de Identidad</v-list-item-title>
                <v-list-item-subtitle>{{ usuario.funcionario.ci }} {{ usuario.funcionario.ci_adid }}
                  {{ usuario.funcionario.expedido }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Sexo</v-list-item-title>
                <v-list-item-subtitle>{{ usuario.funcionario.sexo }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Fecha de Nacimimiento</v-list-item-title>
                <v-list-item-subtitle>{{
                    usuario.funcionario.fecha_nacimiento | moment("DD/MM/YY")
                  }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>Nacionalidad</v-list-item-title>
                <v-list-item-subtitle>{{
                    usuario.funcionario.nacionalidad === 'M' ? 'Masculino' : 'Femenino'
                  }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

          </v-list>
        </v-list-item-content>
      </v-col>
      <v-col cols="5" class="text-center">
        <v-list-item-avatar
            tile
            size="100%"
            color="grey"
        >
          <img v-if="usuario.funcionario.foto === null" src="../assets/images/yaku-user.png" alt="foto"/>
          <img v-else :src="usuario.funcionario.foto" alt="foto">
        </v-list-item-avatar>
      </v-col>
    </v-list-item>
  </v-card>
</template>

<script>
import {mapGetters, mapState} from "vuex";

export default {
  name: "MiPerfil",
  computed: {
    ...mapGetters(['isLogin']),
    ...mapState(['url_base', 'token', 'usuario', 'sistemas'])
  }
}
</script>

<style scoped>

</style>
